import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, tap, throwError } from 'rxjs';

export const LogInterceptor: HttpInterceptorFn = (

  req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  // Test, ob Browserumgebung, da Server Side Rendering zu Problemen mit sessionStorage und Errors führt
  function isBrowser() {
    return typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (isBrowser()) {
        console.log(error.message, error.error)
        return throwError(() => error)
      }
      return EMPTY
    })
  )
};